import React from 'react';
import styles from './TraneCustomerValues.module.css';
import { Row, Col } from 'reactstrap';
import { ReactComponent as BudgetProtectionIcon } from '../../assets/images/Vendor/Trane/budget-protection.svg';
import { ReactComponent as NoHiddenFeesIcon } from '../../assets/images/Vendor/Trane/No-hidden-fees.svg';
import { ReactComponent as ReliableServiceIcon } from '../../assets/images/Vendor/Trane/reliable-service-shield-trane.svg';

const TraneCustomerValues = () => {
    return (
        <Row className={styles.customerValuesContainer}>
            <Col
                className={styles.customerValuesColumn}
                md='12'
            >
                <h1>Adding Value for Your Customers</h1>
                <div className={styles.customerValues}>
                    <div className={styles.valueBox}>
                        <BudgetProtectionIcon />
                        <div className={styles.valueBoxText}>
                            <h3>Budget Protection</h3>
                            <p>Peace of mind for unexpected repair costs during a breakdown</p>
                        </div>
                    </div>
                    <div className={styles.valueBox}>
                        <NoHiddenFeesIcon />
                        <div className={styles.valueBoxText}>
                            <h3>No Hidden Fees</h3>
                            <p>No deductibles, trip or diagnostic fees, fully transferable at no cost</p>
                        </div>
                    </div>
                    <div className={styles.valueBox}>
                        <ReliableServiceIcon />
                        <div className={styles.valueBoxText}>
                            <h3>Reliable Service</h3>
                            <p>Service provided by you, their trusted partner</p>
                        </div>
                    </div>
                </div>
            </Col>
        </Row>
    );
};

export default TraneCustomerValues;
